var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "singleDisbursementModal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("send_pagements.edit_payment"),
            "close-on-click-modal": false,
            width: "910px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("send_pagements.single_payment_details")) +
                " "
            ),
          ]),
          _c("div", { staticClass: "section-tip" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "tips.select_receiving_channel_and_fill_payments_details"
                  )
                ) +
                " "
            ),
          ]),
          _c(
            "div",
            { staticClass: "form-container" },
            [
              _c(
                "el-form",
                {
                  ref: "singleDisbursementForm",
                  attrs: {
                    model: _vm.singleDisbursementForm,
                    "status-icon": "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "merchantAccount.recipient_channel"
                                ),
                                prop: "code",
                                rules: [
                                  {
                                    required: true,
                                    message:
                                      "Receiving channel cannot be empty",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "select-item",
                                  attrs: { filterable: "", clearable: "" },
                                  on: { change: _vm.disbursementChannelChange },
                                  model: {
                                    value: _vm.singleDisbursementForm.code,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.singleDisbursementForm,
                                        "code",
                                        $$v
                                      )
                                    },
                                    expression: "singleDisbursementForm.code",
                                  },
                                },
                                _vm._l(_vm.bankList, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name_with_full_bank,
                                      value: item.bank_code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "send_pagements.recipient_account_number"
                                ),
                                prop: "account_no",
                                rules: [
                                  {
                                    required: true,
                                    message:
                                      "Recipient account number cannot be empty",
                                    trigger: "blur",
                                  },
                                  {
                                    validator: _vm.checkoutAccountNo,
                                    trigger: ["blur", "change"],
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  placeholder: "Enter recipient account number",
                                  maxlength: "50",
                                  autocomplete: "off",
                                  "show-word-limit": "",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.singleDisbursementForm.account_no,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.singleDisbursementForm,
                                      "account_no",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "singleDisbursementForm.account_no",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("merchantAccount.recipient_name"),
                                prop: "account_name",
                                rules: [
                                  {
                                    required: true,
                                    message: "Recipient name cannot be empty",
                                    trigger: "blur",
                                  },
                                  {
                                    validator: _vm.checkWhitespace,
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  placeholder: "Enter recipient name",
                                  autocomplete: "off",
                                  clearable: "",
                                  maxlength: "100",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value:
                                    _vm.singleDisbursementForm.account_name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.singleDisbursementForm,
                                      "account_name",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "singleDisbursementForm.account_name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("components.amount"),
                                prop: "amount",
                                rules: [
                                  {
                                    required: true,
                                    message: "Amount cannot be empty",
                                    trigger: ["blur", "change"],
                                  },
                                  {
                                    validator: _vm.checkAmount,
                                    trigger: ["blur", "change"],
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-item",
                                attrs: {
                                  type: "text",
                                  placeholder: "Enter amount",
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.singleDisbursementForm.amount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.singleDisbursementForm,
                                      "amount",
                                      $$v
                                    )
                                  },
                                  expression: "singleDisbursementForm.amount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("customerService.email_address"),
                                prop: "email",
                                rules: [
                                  {
                                    type: "email",
                                    message: "Please input the correct email",
                                    trigger: ["blur", "change"],
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  placeholder: "Enter email address",
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.singleDisbursementForm.email,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.singleDisbursementForm,
                                      "email",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "singleDisbursementForm.email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("data.remark") } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  autocomplete: "off",
                                  placeholder: "Enter your message here",
                                  maxlength: "256",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.singleDisbursementForm.remark,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.singleDisbursementForm,
                                      "remark",
                                      $$v
                                    )
                                  },
                                  expression: "singleDisbursementForm.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-submit",
                  attrs: { type: "info", disabled: _vm.submiting },
                  on: { click: _vm.onClickSubmitBtn },
                },
                [_vm._v("Submit")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }